import type { KioskCurrentEntry } from '../types';

interface ClockedInListProps {
  entries: KioskCurrentEntry[];
}

function formatSince(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

/**
 * The currently clocked-in employees for this department. This list is
 * server-authoritative (`GET /kiosk/current`) — only the server can resolve PINs
 * to people — and is refreshed after each successful punch/sync.
 */
export function ClockedInList({ entries }: ClockedInListProps): JSX.Element {
  return (
    <div className="card clocked">
      <h2>Clocked in ({entries.length})</h2>
      {entries.length === 0 ? (
        <p className="clocked__empty">No one is clocked in.</p>
      ) : (
        <ul className="clocked__list">
          {entries.map((entry) => (
            <li key={`${entry.employeeId}:${entry.clockInAt}`} className="clocked__item">
              <span>{entry.displayName}</span>
              <span className="clocked__since">since {formatSince(entry.clockInAt)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
